/* eslint-disable */
<template>
    <div>
        <BasicCard v-if="p_loading" v-bind:title="`Caricamento dati`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover v-if="show_action"><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click.stop="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
            </v-hover>
            <BasicCard 
                :title="r_types[report.op_type].name">
                <div class="d-flex flex-column">
                    <RowComponent
                        :label="`codice ordine`"
                        :value="operation.order_nr">
                    </RowComponent>
                    <RowComponent
                        :label="`data ordine`"
                        :value="getFormattedDate(operation.order_date)">
                    </RowComponent>
                    <RowComponent
                        :label="`data intervento`"
                        :value="getFormattedDate(operation.op_date)">
                    </RowComponent>
                    <RowComponent
                        :label="`codice report`"
                        :value="report.code">
                    </RowComponent>
                    <RowComponent 
                        v-if="report.owner_id" 
                        label="eseguito da"
                        :value="`${$store.state.users[report.owner_id].name} il ${getFormattedDate(report.report_date)}`">
                    </RowComponent>
                    <RowComponent 
                        v-if="report.reviewer" 
                        label="revisionato da"
                        :value="`${$store.state.users[report.reviewer].name} il ${getFormattedDate(report.review_date)}`">
                    </RowComponent>
                    <RowComponent 
                        label="stato del report"
                        :value="status_name">
                    </RowComponent>
                    
                    <RowComponent
                        v-if="report.other_info.procedure_code"
                        :label="`procedura taratura`"
                        :value="report.other_info.procedure_code">
                    </RowComponent>
                    <RowComponent
                        v-if="report.other_info.receiving_date"
                        :label="`data ricevimento in sede`"
                        :value="report.other_info.receiving_date">
                    </RowComponent>
                    <ReportCustomData 
                        :o_data="report.custom_data"
                        :op_type="report.op_type"
                        :c_type="'object'"
                        :show_info="true"
                        ref="custom_data"
                        />
                    
                </div>
            </BasicCard>
            <BasicCard>
                <template v-slot:title>
                    <div class="d-flex flex-grow-1 align-center" @click="c_expand.instrument=!c_expand.instrument">
                        <StatusIcon icon_color="white" class="mx-2" :status="getStatusIcon(instrument, {op_type:report.op_type})" :key="instrument.updated"/>
                        {{ instrument.name }}/{{instrument.manufacturer}} - {{ instrument.model }} - {{ instrument.serno}}
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.instrument=!c_expand.instrument">
                        <v-icon class="white--text" v-if="c_expand.instrument">expand_less</v-icon>
                        <v-icon class="white--text" v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.instrument" class="d-flex flex-column">
                    <RowComponent
                        label="famiglia"
                        :value="families[instrument.family].label"
                    />
                    <RowComponent
                        label="numero seriale"
                        :value="instrument.serno"
                    />
                    <RowComponent
                        label="marca"
                        :value="instrument.manufacturer"
                    />
                    <RowComponent
                        label="modello"
                        :value="instrument.model"
                    />
                    <RowComponent
                        label="codice utente"
                        :value="instrument.name"
                    />
                    <RowComponent
                        label="versione software"
                        :value="instrument.sw_version"
                    />
                    <RowComponent
                        label="note"
                        :value="instrument.description"
                    />
                </div>
                
            </BasicCard>
            <BasicCard>
                <template v-slot:title>
                    <div class="d-flex flex-grow-1" @click="c_expand.client=!c_expand.client">
                        <StatusIcon class="mx-2" icon_color="white" :status="getStatusIcon(client)"/>{{ client.name }} - {{ location.name }}
                    </div>
                </template>
                <template v-slot:action>
                    <span @click="c_expand.client=!c_expand.client">
                        <v-icon class="white--text" v-if="c_expand.client">expand_less</v-icon>
                        <v-icon class="white--text" v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.client" class="d-flex flex-column">
                    <RowComponent
                        :value="client.name"
                        :hide_label=true> 
                        P.IVA: {{ client.piva }}
                    </RowComponent>
                    <RowComponent
                        v-bind:value="location.name"
                        v-bind:hide_label=true>
                        <div v-if="location.department_id">
                            <b>Reparto:</b> {{ location.departments[location.department_id].name }}
                        </div>
                        {{ location.address }} {{ location.addrNum }}<br/>
                        {{ location.zip }} {{ location.city }}<br/>
                        {{ location.country }}
                    </RowComponent>
                    <RowComponent
                        label="luogo esecuzione:">
                        <div v-if="report.on_site_execution">Sede cliente</div>
                        <div v-else class="d-flex mt-2 mx-2">
                            {{report.address_execution.address}} {{report.address_execution.addrNum}}}}<br/>
                            {{ report.address_execution.zip}} {{report.address_execution.city}}
                        </div>
                    </RowComponent>
                </div>
            </BasicCard>
            <!--BasicCard :title="`Modello per misure`">
                <div class="d-flex pa-2" v-if="old_reports.length>0">
                    <span v-if="old_reports.length>0"><b class="subtile-2">report precendenti</b></span>
                    <v-autocomplete dense outlined
                        class="ml-2"
                        :items="old_reports"
                        @change="cloneReport"
                        return-object
                        label="report precedenti"
                        item-text="_id"
                        v-model="old_to_clone"
                        />
                    <v-divider></v-divider>
                </div>
                <div class="d-flex flex-column pa-2">
                    <b class="d-flex subtile-2" v-if="old_reports.length>0">Master</b>
                    <div class="d-flex" v-for="(p_id, p_idx) of Object.keys(report.pl_reports)" :key="p_id">
                        <div class="d-flex flex-grow-1 flex-shrink-0 flex-column">
                            <div class="d-flex">Piattaforma {{p_idx+1}} - {{ platforms[p_id].i_data.family }}</div>
                            <InstrumentPlatformInfo class="d-flex "
                                v-bind:o_data="platforms[p_id].i_data"
                                :show_divider="false"/>
                        </div>
                        <v-autocomplete dense outlined
                            class="d-flex flex-shrink-1 flex-grow-0 ml-2 align-start justify-end"
                            :items="platforms[p_id].masters"
                            v-model="platforms[p_id].master"
                            label="master*"
                            return-object
                            @change="initMeasurePlat(p_id)"
                            item-text="name"
                            :rules="[rules.mandatory]" 
                            />
                    </div>
                </div>
                <div class="d-flex justify-end pa-2">
                    <v-btn :disabled="!enable_measure" @click.stop="start_measures">Inizia le misure</v-btn>
                </div>
            </BasicCard>-->
            <div class="d-flex flex-column" >
                <BasicCard v-for="(p_id, p_idx) of Object.keys(report.pl_reports)" :key="p_id" :title="`Dispositivo ${p_idx+1} - ${families[platforms[p_id].family].label}`">
                    <InstrumentPlatformInfo class="d-flex pa-2"
                        v-bind:o_data="platforms[p_id]"
                        :show_divider="false"/>
                    
                    <div class="d-flex flex-column" 
                        v-if="report.pl_reports[p_id] && report.pl_reports[p_id].blocks && report.pl_reports[p_id].blocks.length>0" :key="report.pl_reports[p_id].id">
                        <RowComponent class="my-2" v-if="report.pl_reports[p_id].chosen_tolerance">
                            <template v-slot:label>
                                <div class="text-subtitle-1 font-weight-bold text-uppercase">
                                    tolleranza
                                </div>
                            </template>
                            <span class="d-flex font-weight-bold mr-3">{{ tol_dict[report.pl_reports[p_id].chosen_tolerance.t_type].text }}</span>
                            <div v-if="report.pl_reports[p_id].chosen_tolerance.t_type!='law'">
                                <div class="d-flex flex-column " v-if="report.pl_reports[p_id].chosen_tolerance.value == 'instrument'">
                                    <div v-for="t_ins of report.pl_reports[p_id].chosen_tolerance.t_vals" :key="t_ins.test_type">
                                    <span class="mr-1">{{tol_instr_type[t_ins.test_type]}} - {{t_ins.t_val | formatNumber }}</span><span v-if="t_ins.t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <span class="mr-1">{{report.pl_reports[p_id].chosen_tolerance.t_vals[0].t_val  | formatNumber }}</span><span v-if="report.pl_reports[p_id].chosen_tolerance.t_vals[0].t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                </div>
                            </div>
                        </RowComponent>
                        <v-divider />
                        <div>
                            <div class="px-2 my-2 font-weight-bold subtitle-1 text-uppercase">Masse di lavoro</div>
                            <RowComponent
                                v-for="primary in report.pl_reports[p_id].primaries"
                                :key="primary._id"
                                :label="primary.family">
                                <div class="body-2 d-flex flex-column"> 
                                    <div class="d-flex flex-column justify-start" v-if="primary.family != 'zavorra'">
                                        <div class="font-weight-bold"><span v-if="primary.name!=''">{{ primary.name }}<br/></span>{{ primary.serno}} - {{ primary.model }} - {{ primary.manufacturer}} * {{ pfamilies[primary.family].label }}</div>
                                        <div class="caption font-italic">
                                            cert. n°: <span class="font-weight-bold">{{primary.primary_data.certificate_nr}}</span>, emesso da <span class="font-weight-bold">{{primary.primary_data.certificate_authority}}</span> il <span class="font-weight-bold">{{primary.primary_data.emission | formatDateTS }}</span><br/>
                                            scadenza: <span class="font-weight-bold">{{primary.primary_data.expire | formatDateTS }}</span><br/>
                                            <span v-if="primary.primary_data.min_use && primary.primary_data.max_use && primary.primary_data.uom">range di funzionamento: <span class="font-weight-bold">{{primary.primary_data.min_use}}{{primary.primary_data.uom}} - {{primary.primary_data.max_use}}{{primary.primary_data.uom}}</span></span>
                                        </div>
                                    </div>
                                </div>
                            </RowComponent>
                        </div>
                            <!--InstrumentPlatformInfo class="d-flex flex-grow-1 flex-shrink-0 flex-column"
                                v-for="primary in report.pl_reports[p_id].primaries"
                                :key="primary._id"
                                v-bind:o_data="primary"
                                :show_divider="false"/-->
                        <div class="subtitle-1 my-2 px-2 font-weight-bold text-uppercase">MISURE</div>
                        <v-expansion-panels class="d-flex">
                            <v-expansion-panel
                                class="pa-0 ma-0"
                                v-for="(element, idx) in report.pl_reports[p_id].blocks"
                                :key="element.id" v-model="panels[p_id][idx]">
                                <v-expansion-panel-header color="expansion">
                                    <template v-slot:default="{ open }">
                                    <v-row no-gutters>
                                        <v-col cols="10" class="text-uppercase pa-0 ma-0 font-weight-bold">{{ idx+1 }} - {{ element.label }}</v-col>
                                        <v-col
                                        cols="2"
                                        class="d-flex justify-end pr-2"
                                        >
                                        <v-fade-transition leave-absolute>
                                            <span
                                            v-if="open"
                                            key="0"
                                            >
                                            </span>
                                            <span
                                            v-else-if="report.pl_reports[p_id].blocks[idx].measures && report.pl_reports[p_id].blocks[idx].measures.result"
                                            key="1"
                                            >
                                                <StatusIcon 
                                                :status="report.pl_reports[p_id].blocks[idx].measures.result" 
                                                :tooltip_text="block_tooltip[report.pl_reports[p_id].blocks[idx].measures.result]"/>
                                            </span>
                                            <span v-else key="1">
                                                <StatusIcon status="missing" :tooltip_text="block_tooltip['missing']" />
                                            </span>
                                        </v-fade-transition>
                                        </v-col>
                                    </v-row>
                                </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="ma-0 pa-0">
                                <dynamiclink class="mb-2" 
                                    type="layout"
                                    :data="{'block': element, 'b_index': idx, 'instrument_data':platforms[p_id], 'p_idx': p_idx, 'p_id': p_id, 'm_static': report.pl_reports[p_id].static, primaries: report.pl_reports[p_id].primaries, selected_mode: report.pl_reports[p_id].selected_mode, common_data: report.pl_reports[p_id].common_data }" :preview="true">
                                </dynamiclink>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                    <v-subheader class="font-weight-bold" v-else >
                        Nessuna misura effettuata
                    </v-subheader>
                    
                </BasicCard>
                <BasicCard v-if="report.status!='new'" title="Osservazioni conclusive">
                    <div v-if="report.history && report.history.length>0">
                        <RowComponent
                            label="storico">
                                <div class="d-flex flex-column full-width"> 
                                <div v-for="h in report.history" :key="h.rev">
                                    <div class="font-weight-bold text-uppercase" @click="goToReportDetails(h.prev_report)">revisione {{ h.rev }}</div>
                                    <div class="d-flex flex-column">
                                        <span class="d-flex"><span class="font-italic">eseguito il {{getFormattedDate(h.report_date)}}</span> - {{ h.remarks}}</span>
                                        <span class="d-flex"><span class="font-italic">riesaminato il {{getFormattedDate(h.review_date)}}</span> - {{ h.review_remarks}}</span>
                                    </div>
                                </div>
                                </div>
                        </RowComponent>
                    </div>
                    <v-form v-model="valid_review" ref="review_form">
                    <RowComponent 
                        v-if="report.remarks" 
                        label="tecnico"
                        :value="report.remarks">
                    </RowComponent>
                    <v-textarea v-if="review" dense outlined class="pa-4" v-model="report.review_remarks" rows="3" label="note revisore*" :rules="[rules.mandatory]">
                    </v-textarea>
                    <div v-else>
                        <RowComponent 
                            v-if="report.review_remarks"
                            label="revisore"
                            :value="report.review_remarks">
                        </RowComponent>
                    </div>
                    <div v-if="report.status!='new' && report.status!='measuring'" class="d-flex flex-column">
                        <span v-if="review" class="px-4"><CalendarField
                            v-model="report.review_date"
                            :minDate="report.report_date"
                            label="data review*"
                            :rules="[rules.mandatory]"
                        ></CalendarField></span>
                        <RowComponent
                            v-else 
                            label="data riesame"
                            :value="getFormattedDate(report.review_date)">
                        </RowComponent>
                        <v-alert type="warning" v-if="report.status == 'revised'">
                            report non approvato dal revisore
                        </v-alert>
                        <RowComponent
                            v-if="report.report_pdf_path" 
                            label="report"
                            >
                            <a :href="getCertPath()+''+report.report_pdf_path" target="_blank">report</a>
                        </RowComponent>
                        <RowComponent
                            v-if="report.certificate_path" 
                            label="attestato"
                            >
                            <a :href="getCertPath()+''+report.certificate_path" target="_blank">attestato</a>
                        </RowComponent>
                        <RowComponent
                            v-if="report.signed_path" 
                            label="attestato firmato"
                            >
                            <a :href="getCertPath()+''+report.signed_path" target="_blank">attestato firmato</a>
                        </RowComponent>
                        <RowComponent
                            v-for="(primary, index) in primaries" :key="index"
                            :label="'Certificato per '+primary.name"
                            >
                            <a :href="getCertPath()+''+primary.path" target="_blank">certificato</a>
                        </RowComponent>

                    </div>
                </v-form>
                </BasicCard>
                <div v-if="show_action">
                    <div v-if="review" class="ma-2 d-flex align-center justify-center py-4">
                        <v-btn v-if="next_status.includes('reviewed')" :disabled="!valid_review" class="mx-1" color="primary" @click.stop="saveExit('reviewed')">Riesame OK</v-btn>
                        <v-btn v-if="next_status.includes('revising')" :disabled="!valid_review" class="mx-1" color="alert" @click.stop="saveExit('revising')">Da rivedere</v-btn>
                        <v-btn v-if="next_status.includes('failed')" :disabled="!valid_review" class="mx-1" color="error" @click.stop="saveExit('failed')">Riesame KO</v-btn>
                        <v-btn v-if="next_status.includes('deleted')" class="mx-1" text @click.stop="saveExit('deleted')">Elimina report</v-btn>
                        <v-btn class="mx-1" text @click.stop="close">annulla</v-btn>
                    </div>
                    <div class="ma-2 d-flex align-center justify-center my-4" v-else>
                        <v-btn class="mx-1" text @click.stop="close">chiudi</v-btn>
                    </div>
                </div>
            </div>
            </div>
            <BaseDialog 
                :max_width="`300`"
                :dialog="show_alert"
                title="Attenzione"
                v-on:close_dialog="close"
            >
                <p>
                    Il report non è più modificabile.
                </p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="close">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
            <BaseDialog 
                :max_width="`300`"
                :dialog="show_error"
                title="Attenzione"
                v-on:close_dialog="close">
                <p>
                    Si è presentato un errore inaspettato!
                </p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="close">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
        </div>
</template>

<script>
/* import repeatiblity from "../../blocks/layout/repeatability_nawi"
import eccentricity from "../../blocks/layout/eccentricity_nawi"
import linearity from "../../blocks/layout/linearity_nawi"
import visualcheck from "../../blocks/layout/D_visualcheck_nawi"
import {i_families} from "../../utils/common.js"
*/
// import _ from 'lodash'
import { f_rules, formatDatefromTS, getObjStatus, getCertificatePath } from '../../utils/commonUtils'
import { rStatusCanChange, report_status_transition} from "../../utils/statusManagement"
import {report_type, block_status_tooltip, tolerance, i_families , p_families} from "../../utils/common"
import BasicCard from '../../components/utils/Basic_card.vue'
import BaseDialog from '../../components/dialogs/BaseDialog'
import RowComponent from '../../components/utils/RowComponent.vue'
import StatusIcon from '../../components/utils/StatusIcon'
import dynamiclink from '../../components/utils/Block_Dynamic_link.vue'
import ReportCustomData from "./Report_utils/ReportCustomData"
import InstrumentPlatformInfo from "../instruments/Instrument_utils/Instrument_platform_info"

export default {
    components: {
        dynamiclink, BasicCard, RowComponent, ReportCustomData, InstrumentPlatformInfo, StatusIcon, BaseDialog
        // , repeatiblity, eccentricity, linearity, visualcheck
    },
    props: {
        report_id: {
            type: String,
            required: false,
            default: null
        },
        review: {
            type: Boolean,
            required: false,
            default: false
        },
        back: {
            type: String,
            required: false,
            default: null
        },
        is_section: {
            type: Boolean,
            required: false,
            default: false
        },
        show_action: {
            type: Boolean,
            required: false,
            default: true
        }
    },
  
    data() {
        return {
            report: null,
            operation: null,
            instrument: null,
            client: null,
            location: null,
            p_loading: true,
            platforms: {},
            panels: {},
            c_expand: {
                instrument: false,
                client: false,
            },
            rules:f_rules,
            r_types: report_type,
            order_date: '',
            procedures: [],
            show_alert: false,
            show_close_alert: false,
            show_error: false,
            closing_status: '',
            primaries: [],
            valid_review: false,
            block_tooltip: block_status_tooltip,
            tol_dict: {},
            tol_instr_type: {},
            families: i_families,
            pfamilies: p_families
        }
    },
    async mounted() {
        this.p_loading = true
        this.report = await this.$store.state.$pouch.get('reports', this.report_id)
        this.operation = await this.$store.state.$pouch.get('operations', this.report.operation_id)
        this.instrument = this.report.ext_data.instrument
        this.client = this.report.ext_data.client
        this.location = this.report.ext_data.location
        for( let platform of this.instrument.platforms) {
            this.platforms[platform.id] = platform
            this.panels[platform.id] = []   
        }
        
        this.buildPrimaries()
        this.tol_dict = _.keyBy(tolerance._type, t => t.id);
        this.tol_instr_type = tolerance._instrument_label[this.instrument.family]
        this.p_loading = false
    },
    computed: {
        status_name() {
            return report_status_transition[this.report.op_type][this.report.status].name
        },
        next_status() {
            return report_status_transition[this.report.op_type][this.report.status].next
        }
    },
    watch: {
    },
    methods: {
        getCertPath() {
            return getCertificatePath()
        },
        getStatusIcon(obj, data) {
            if (!data){
                data = null
            }
            return getObjStatus(this.$store.state.config.threshold, obj, data)
        },
        getFormattedDate(ts) {
            return formatDatefromTS(ts)
        },
        close() {
            this.show_alert = false
            this.show_close_alert = false
            this.show_error = false
            if (this.is_section) {
                this.$emit('hide_report')
            } else {
                if (this.back){
                    this.$router.push({path: this.back})
                } else {
                    this.$router.push({path: '/reports/list'})
                }
            }
        },
        closeWithAlert(status) {
            this.show_close_alert = true
            this.closing_status = status
        }, 
        async saveExit(status) {
            let res = await this.changeStatus(status)
            if (res) {
                if (this.is_section) {
                    this.$emit('report_updated', {r_id: this.report_id, status:status })
                } else {
                    this.$root.$emit('remote_operation_update', {type: 'report', r_id: this.report_id, status:status })
                }
                this.close()
            } else {
                // alert popup
            }
        },
        
        async saveReport(){
            this.report.reviewer = this.$store.state.user._id
            this.report.approved = (new Date()).getTime()
            let r_res = await this.$store.state.$pouch.put('reports', this.report)
            if (r_res.ok) {
                this.report._rev = r_res.rev
            }
        },
        async changeStatus(newStatus) {
            try {
                console.log('change status', newStatus)
                if (rStatusCanChange(this.report.op_type, this.report.status, newStatus)) {
                    console.log('change status allowed', newStatus)
                    this.report.status = newStatus
                    await this.saveReport()
                    return true
                } else {
                    return false
                }
            } catch(error) {
                console.log('error', error)
                return false
            }
        },
        buildPrimaries(){
            for(var [id, platform] of Object.entries(this.report.pl_reports)){
                if(platform && platform.primaries){
                    for(let primary of platform.primaries){
                        if(primary.family != "zavorra" && !this.primaries.find(element => {
                            if(element._id == primary._id) { return true } else { return false }}) )
                            {
                                this.primaries.push({_id: primary._id, name: primary.name, path: primary.primary_data.certificate_ref})
                            }
                    }
                }
            }
        },
        goToReportDetails(rep_id) {
            this.$router.push({path: "/reports/details", query: {"report_id": rep_id, "back": this.$router.history.current.fullPath}}) 
        },
    }

}
</script>

<style>
.basic_card .v-expansion-panel__header {
    padding: 0px;
    margin:0px;
    min-height: 0px !important;
}

</style>
